import i18next from 'i18next';

// HubSpot-lomakkeiden osoitteet kielittäin. Lomakkeet ovat erillisiä HubSpotissa per kieli
// (HubSpot ei käännä kenttäotsikoita), joten frontti valitsee osoitteen käyttäjän kielen mukaan
// ja putoaa suomeen, jos kieltä ei tunneta. Lomakkeet HubSpotissa (portaali 146833777):
// "Order form / Invoice / PRO / FI", "Order form / Invoice / EN", "Order form / Invoice / SV",
// "Yhteydenottolomake", "Contact form / EN", "Contact form / SV".
//
// Laskutilauslomake ("Order form / Invoice"): esitäytettävät tilauskentät ovat HubSpotin
// sisäisiä kenttänimiä `tenderapaketti`, `laskutusjakso` (YEARLY/SIX_MONTHS/MONTHLY) ja
// `lisakayttajapaikat`. Ne pitää luoda samoilla sisäisillä nimillä myös en/sv-lomakkeisiin,
// muuten esitäyttö ei osu.
// 14.9.2026: HubSpot-lomake korvattu appin omalla modaalilla (InvoiceOrderModal). Perus-URL on vain kantaja
// parametreille, joita kutsupaikat lisäävät; polkua ei avata missään.
const INVOICE_FORM_URLS = {
    fi: 'https://tendera.fi/laskutilaus',
    en: 'https://tendera.fi/laskutilaus',
    sv: 'https://tendera.fi/laskutilaus',
};

// Yhteydenottolomake (sivupalkin "Ota yhteyttä", upotetaan iframeen).
const CONTACT_FORM_URLS = {
    fi: 'https://2ff5o1.share-eu1.hsforms.com/2jeE2CEHhSjG1UhqlJ4zlcA',
    en: 'https://2ff5o1.share-eu1.hsforms.com/2BO66QamkQXa9qJpkfqpqJg',
    sv: 'https://2ff5o1.share-eu1.hsforms.com/2oN0dDJJ0R72cQrllbvbTgg',
};

const FALLBACK_LANGUAGE = 'fi';

const normalizeLanguage = (language) => String(language || '').toLowerCase().split('-')[0];

const pickUrl = (urls, language) => {
    const lang = normalizeLanguage(language ?? i18next.language);
    return urls[lang] || urls[FALLBACK_LANGUAGE];
};

export const getInvoiceFormUrl = (language) => pickUrl(INVOICE_FORM_URLS, language);
export const getContactFormUrl = (language) => pickUrl(CONTACT_FORM_URLS, language);

// Laskutilauksen tilauskentät URL-parametreiksi. Käytetään kaikista laskulla-tilaa-poluista
// (laskutussivu, pakettimodaali, upsell-modaalit), jotta lomake ei koskaan avaudu oletuksella.
// Backend/enum cadence -> HubSpot `laskutusjakso` option value. HubSpot's option list was
// created as YEARLY/SIX_MONTHS/MONTHLY before the backend settled on SEMIANNUAL.
const HUBSPOT_BILLING_INTERVAL = { SEMIANNUAL: 'SIX_MONTHS' };

export const appendInvoiceOrderParams = (url, { planName, billingInterval, extraSeats } = {}) => {
    if (planName) url.searchParams.set('tenderapaketti', String(planName));
    url.searchParams.set('laskutusjakso', HUBSPOT_BILLING_INTERVAL[billingInterval] || billingInterval || 'YEARLY');
    if (extraSeats != null) url.searchParams.set('lisakayttajapaikat', String(extraSeats));
    return url;
};
